import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { selectPackagesByRequiredOfferId } from "../../../balancingSelectors/selectBalancingPackages";
import { selectBalancingShopOfferGroupById } from "../../../balancingSelectors/selectBalancingPurchaseOfferGroups";
import { ScrollOptions } from "../../../constants/ScrollOptions";
import { IdStyles } from "../../../less/IdStyles";
import { selectPlayerLevel } from "../../../selectors/selectPlayerLevelInfo";
import { selectGrowthFundIcon } from "../../../selectors/selectShopInfo";
import { selectTimesPurchasePackageAmount } from "../../../selectors/selectTimesPurchasePackageAmount";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { utilShop } from "../../../utils/utilShop";
import { Badge } from "../../generic/badge/Badge";
import { IdBadgePosition } from "../../generic/badge/IdBadgePosition";
import { ButtonInfoSmall } from "../../generic/common/ButtonInfoSmall";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { List } from "../../generic/list/List";
import { TextLoca } from "../../generic/text/TextLoca";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { OfferLevelRewardListItem } from "./OfferLevelRewardListItem";
var renderLevelReward = function (levelReward, playerLevel, onSelectTimesPurchasePackageBought, offerCharacteristicId, onTryCollect) {
    var requPlayerLevel = levelReward.requPlayerLevel || 0;
    var isEnabled = playerLevel >= requPlayerLevel;
    var maxPurchases = levelReward.maxPurchases || 1;
    var timesPurchasePackageAmount = onSelectTimesPurchasePackageBought(levelReward.id);
    var hasBeenCollected = timesPurchasePackageAmount.greaterThanOrEqual &&
        timesPurchasePackageAmount.greaterThanOrEqual(maxPurchases);
    return (React.createElement(OfferLevelRewardListItem, { isEnabled: isEnabled, hasBeenCollected: hasBeenCollected, levelReward: levelReward, offerCharacteristicId: offerCharacteristicId, key: levelReward.id + "_" + levelReward.resourceReward, onTryCollect: onTryCollect }));
};
var _OfferLevelReward = function (_a) {
    var locaKeyFlavour = _a.locaKeyFlavour, offerCharacteristicId = _a.offerCharacteristicId, getTimePurchasePackageAmount = _a.getTimePurchasePackageAmount, openInfoMenu = _a.openInfoMenu, playerLevel = _a.playerLevel, onTryCollect = _a.onTryCollect;
    var levelRewards = selectPackagesByRequiredOfferId(offerCharacteristicId);
    var balancingShopOfferGroup = selectBalancingShopOfferGroupById(offerCharacteristicId);
    var locaHeader = balancingShopOfferGroup && balancingShopOfferGroup.locaKeyHeader
        ? balancingShopOfferGroup.locaKeyHeader
        : IdLoca.xInTotal;
    var totalRewardAmount = utilShop.getTotalRewardAmount(levelRewards);
    var totalRewardReplacements = new Map([
        [ReplacementLoca.zero_0, utilNumber.format(totalRewardAmount)],
    ]);
    var icon = selectGrowthFundIcon(levelRewards);
    var packageList = (React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "offer-body__reward-list" },
        React.createElement(List, { items: levelRewards, renderItem: function (item) {
                return renderLevelReward(item, playerLevel, getTimePurchasePackageAmount, offerCharacteristicId, onTryCollect);
            } })));
    var infoBadge = (React.createElement(Badge, { position: IdBadgePosition.TopRight },
        React.createElement(ButtonInfoSmall, { onClick: openInfoMenu },
            React.createElement(Icon, { icon: IdIcon.InfoIcn, styleId: IdStyles.IconSmall }))));
    return (React.createElement("div", { className: "offer-body__rewards" },
        React.createElement("div", { className: IdStyles.OfferDetailsHeader + " offer-body__rewards-container offer-body__rewards-container-level" },
            React.createElement(Icon, { icon: icon, styleId: IdStyles.IconMedium }),
            React.createElement("div", { className: "offer-body__rewards-header-text" }, totalRewardAmount > 0 && (React.createElement(TextLoca, { id: locaHeader, replacements: totalRewardReplacements, className: IdStyles.HeadlineOne })))),
        React.createElement("div", { className: IdStyles.OfferLevelRewardListBackground + " offer-body__level-reward-list-container flex flex--aligned flex--stacked" },
            React.createElement("div", { className: "offer-body__reward-list-header-container" },
                locaKeyFlavour && (React.createElement(TextLoca, { id: locaKeyFlavour, className: IdStyles.TextBoldSecondary + " offer-body__level-reward-list-header" })),
                infoBadge),
            packageList)));
};
var mapState = function (state) {
    return {
        getTimePurchasePackageAmount: function (id) { return selectTimesPurchasePackageAmount(state, id); },
        playerLevel: selectPlayerLevel(state),
    };
};
var mapDispatch = function (dispatch) {
    return {
        openInfoMenu: function () { return dispatch(actionModalOpen(IdModal.ShopGrowingGoldOffer)); },
    };
};
export var OfferLevelReward = connect(mapState, mapDispatch)(_OfferLevelReward);



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferLevelReward.tsx
// module id = 2915
// module chunks = 3